import { action, observable, makeObservable } from 'mobx';

import { DeviceData, DeviceStatus, DeviceUpdateForm } from 'chaika-frontend-types/frontend-cms';

export class Device {
    @observable
    public readonly id: string;

    @observable
    public readonly organizationId: string;

    @observable
    public name: string;

    @observable
    public inventoryNumber?: string;

    @observable
    public aeTitle: string;

    @observable
    public typeId: string;

    @observable
    public status: DeviceStatus;

    @observable
    public creationTime: string;

    constructor(
        {
            id,
            name,
            aeTitle,
            inventoryNumber,
            organizationId,
            typeId,
            status,
            creationTime,
        }: DeviceData = {} as DeviceData,
    ) {
        makeObservable(this);

        this.id = id;
        this.name = name;
        this.aeTitle = aeTitle || '';
        this.organizationId = organizationId;
        this.inventoryNumber = inventoryNumber ?? '';
        this.typeId = typeId;
        this.status = status;
        this.creationTime = creationTime;
    }

    @action
    public update(params: DeviceUpdateForm): void {
        const {
            name = this.name,
            aeTitle = this.aeTitle,
            typeId = this.typeId,
            inventoryNumber = this.inventoryNumber,
        } = params;

        this.name = name;
        this.aeTitle = aeTitle;
        this.typeId = typeId;
        this.inventoryNumber = inventoryNumber;
    }

    @action
    public setStatus(status: DeviceStatus): void {
        this.status = status;
    }
}
